import ActionType from '../action';

export function setSystemConfigurations(payload) {
  return ({ type: ActionType.CHANGE_SYSTEM_CONFIG, payload});
}

export default {
  setSystemConfigurations
}
